import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DashboardApp } from 'src/environments/environment.type';

@Component({
  selector: 'afoone-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public dashboardApps: DashboardApp[] = [];

  ngOnInit(): void {
    if (environment.dashboardApps) {
      this.dashboardApps = environment.dashboardApps;
    }

    console.log(this.dashboardApps);

  }


}
